import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { notifyDanger } from '@gandi/notifications';
import { sendCommerce, setProps } from '@gandi/tracking';
import { useTranslator } from '@gandi/translate';
import { selectCartCurrency } from '../../../../../../modules/selectors';
import { useSuggestionTexts } from '../../../../../../modules/suggest/hooks';
import LongWordBreaker from '../../../../LongWordBreaker';
import { useGetTotalPrice } from '../../helpers';
import { addProductSuggestionToCart } from '../../modules/actions';
import Suggestion from './Suggestion';
import { jsx as _jsx } from "react/jsx-runtime";
const DOMAIN_PRODUCTS = ['domains', 'mailboxv2', 'domain_option'];
export default function ProductSuggestionItem({
  product
}) {
  const dispatch = useDispatch();
  const {
    __,
    formatPrice
  } = useTranslator();
  const currency = useSelector(selectCartCurrency);
  const getTotalPrice = useGetTotalPrice();
  const {
    title,
    description,
    details
  } = useSuggestionTexts(product);
  const {
    total,
    suggestionId
  } = product;
  const price = formatPrice(getTotalPrice(total), currency);
  const isProductDomain = DOMAIN_PRODUCTS.includes(product.product_type);
  React.useEffect(() => {
    if (currency && product && price) {
      const productQuantity = product.prices?.length ? product.prices[0].quantity : 1;
      sendCommerce({
        name: 'product.display',
        data: {
          product_id: product.product_type,
          product: `${product.product_type} - ${product.process}`,
          product_variant: `${product.payload.duration}${product.payload.duration_unit || 'y'}`,
          product_brand: isProductDomain ? 'Produits registres' : 'Produits Gandi',
          product_discount: product.discount_code !== '',
          product_pricetaxincluded: total.after_taxes,
          product_pricetaxfree: total.before_taxes,
          product_currency: currency,
          product_stock: true,
          product_quantity: productQuantity,
          customObject: {
            ...product.metadatas,
            product_placement: 'cartwidget'
          }
        }
      });
    }
  }, [currency, product, price, total, isProductDomain]);
  const handleClick = productSuggestion => async () => {
    try {
      setProps({
        ...product.metadatas,
        product_placement: 'cartwidget'
      }, {
        events: ['product.add_to_cart']
      });
      await dispatch(addProductSuggestionToCart(productSuggestion));
    } catch (e) {
      const message = e.message || e._error || __('Cannot add %(suggestion)s to cart', {
        suggestion: title
      });
      dispatch(notifyDanger({
        message
      }));
    }
  };
  return /*#__PURE__*/_jsx(Suggestion, {
    id: suggestionId,
    title: /*#__PURE__*/_jsx(LongWordBreaker, {
      children: title
    }),
    price: price,
    description: description,
    onClick: handleClick(product),
    children: details
  });
}